/* eslint-disable eqeqeq */
/* eslint-disable quotes */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable no-console */
// Imports defined
import React, { useEffect, useRef, useState } from 'react';
import './bannerSingleImage.css';

function BannerSingleImage(props) {
  const { img } = props;
  const [imgEffect, setImgEffect] = useState(false);
  const iconContainer = useRef();

  const animationHandler = (e) => {
    if (!imgEffect) {
      setImgEffect(true);
      e.target.style.transform = 'scale(1.2)';
    } else {
      setImgEffect(false);
      e.target.style.transform = 'scale(1)';
    }
  };

  return (
    <div
      onMouseEnter={(e) => animationHandler(e)}
      onMouseLeave={(e) => animationHandler(e)}
      className="iconContainer"
    >
      <img src={img || ''} alt="" ref={iconContainer} />
    </div>
  );
}

export default BannerSingleImage;
